module.exports = __webpack_public_path__ + "img/symbol_5.99da069a.png";